import React from 'react'
/* --------------------------------------------- */
/* --------------------------------------------- */
import "../_landing-page.scss";

/* --------------------------------------------- */
// GenericBottom component for showing pageComponent
const GenericBottom = (props) => {
  // const { graphics } = theme
  // eslint-disable-next-line no-unused-vars
  // const [theme, updateTheme] = useState(null)
  const { contentData, channelDataLoaded} = props

  // const { appTheme } = useSelector(store => store.themeConfigReducers)

  /**
   * It: Updates theme.
   */
  // useEffect(() => {
  //   updateTheme(appTheme)
  // }, [appTheme])

  // eslint-disable-next-line no-unused-vars
  const onChannelImageLoad=(idx)=>{
    if(idx === contentData.length - 1){
      // console.log(props)
      channelDataLoaded && channelDataLoaded()
    }
  }
  return (
    <div className="channel-component">
      {
        contentData.map((data, idx) => {
          const {graphics : { img }} = data
          return (
            <div className="channel-section" key={idx}>
              <img src={img} alt="channel"onLoad={()=>onChannelImageLoad(idx)}/>
            </div>
          )
        })
      }
    </div>
  )
}


/* --------------------------------------------- */
GenericBottom.propTypes = {

}
/* --------------------------------------------- */
GenericBottom.defaultProps = {

}
/* --------------------------------------------- */
export default GenericBottom
